import firebase from 'firebase/app'
import 'firebase/auth'
import md5 from 'md5'

// initial state
const state = {
  admin: false,
  approved: false,
  connection: '',
  email: '',
  realName: '',
  username: '',
  volumeControl: false,
  loggedIn: false,
}

// getters
const getters = {
  gravatar: (state) => (id) => {
    return 'https://www.gravatar.com/avatar/' + md5(state.email.trim().toLowerCase())
  },
}

// actions
const actions = {
  setMe ({ commit }, me) {
    commit('commitMe', me)
  },

  async logout ({ dispatch }) {
    await firebase.auth().signOut()
    location.href = '/sign-in'
  },
}

// mutations
const mutations = {
  commitMe (state, me) {
    state.loggedIn = true
    state.admin = me.admin
    state.approved = me.approved
    state.connection = me.connection
    state.email = me.email
    state.volumeControl = me.volumeControl
    state.realName = me.realName
    state.username = me.username
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
